module.exports = __webpack_public_path__ + "static/media/MaternityLeave.178712ad.svg";